import { PricingMode } from '@mews/enums';
import { LocalizedCurrencyValue } from '@mews/framework';

export const LocalizedCurrencySimpleValue = ({ value }: $TSFixMe) => (
    <LocalizedCurrencyValue
        options={{
            pricingMode: PricingMode.Simple,
        }}
        value={value}
    />
);
